import { BoxProps, Card, styled } from '@mui/material';

const PanelCell = styled(Card)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  background: theme.palette.grey[500],
  border: `1px solid ${theme.palette.grey[600]}`,
  borderTopLeftRadius: 3,
  borderTopRightRadius: 3,
  flexGrow: 0.05,
  padding: '10px 15px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
  [theme.breakpoints.up('sm')]: {
    width: '50%',
  },
}));
const Wrapper = styled('section', { shouldForwardProp: (prop) => prop !== 'isChildren' })<
  BoxProps & { isChildren?: boolean }
>(({ theme, isChildren }) => ({
  display: 'flex',
  [theme.breakpoints.down('sm')]: {
    flexWrap: 'wrap',
    gap: 20,
  },
  [theme.breakpoints.up('sm')]: {
    flexWrap: 'nowrap',
    gap: 30,
  },
  marginBottom: 20,
  ...(isChildren && { justifyContent: 'space-between' }),
}));

export { PanelCell, Wrapper };
